import React from 'react'
import PropTypes from 'prop-types'
import { 
	Formik, 
	Form,
	FastField 
} from 'formik'
import { noteDefaults } from '@modules/note/note.module.js'

import './NoteInput.scss'

export default class NoteInput extends React.Component {

	static propTypes = {
		onSubmit: PropTypes.func.isRequired,
	};

	get initialValues() {
		return this.props.note
			? this.props.note
			: noteDefaults;
	}

	handleEnter() {
		// TODO: allow modified enter for submit
	}

	render() {
		const { 
			onSubmit,
		} = this.props;

		return (
			<Formik
				initialValues={noteDefaults}
				onSubmit={onSubmit}
 			>
 				{({resetForm, dirty}) => {
 					return (
		 				<Form className="NoteInput" onKeyPress={::this.handleEnter}>
		 					<p><b>Add a new note</b></p>
							<FastField rows="8" name="content" component="textarea" placeholder="New Note..." />
							<div className="NoteInput-buttons">
								{
									dirty
									&& <button type="button" onClick={() => resetForm()}>discard</button>
								}
								<button type="submit" disabled={!dirty}>submit</button>
							</div>
		 				</Form>
	 				)
 				}}
 			</Formik>
		)
	}
}


// WEBPACK FOOTER //
// ./src/scenes/Notes/components/NoteInput/NoteInput.jsx